import { render, staticRenderFns } from "./ClientsLogin.vue?vue&type=template&id=29e4f0b2&scoped=true&"
import script from "./ClientsLogin.vue?vue&type=script&lang=ts&"
export * from "./ClientsLogin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29e4f0b2",
  null
  
)

export default component.exports